import { render, staticRenderFns } from "./PersonalAwayPage.vue?vue&type=template&id=4ffe8c28&scoped=true&"
import script from "./PersonalAwayPage.vue?vue&type=script&lang=js&"
export * from "./PersonalAwayPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffe8c28",
  null
  
)

export default component.exports